export const DefaultLetterSpacing = '0.15px';
